/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technicalnecessary1Inputs */



/**
* | output |
* | --- |
* | "Technically necessary" |
*
* @param {Technicalnecessary1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const technicalnecessary1 = /** @type {((inputs?: Technicalnecessary1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technicalnecessary1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Technically necessary")
	return /** @type {LocalizedString} */ ("Technisch notwendig")
});
export { technicalnecessary1 as "technicalNecessary" }